<div id="wrapper" [ngStyle]="getColumnsPerRow()">
  <ng-container *ngFor="let card of cards">
    <app-card
      [ngStyle]="getColumnStyle(card.size, card.sort)"
      [title]="card.title"
      [titleColor]="card.titleColor ?? 'white'"
      [subtitle]="card.subtitle"
      [imageSrc]="card.imgSrc"
      [link]="card.link"
      [circleImgSrc]="card.circleImgSrc"
      [circleSizePx]="card.circleSizePx"
      [titlePosition]="card.titlePosition"
    ></app-card>
  </ng-container>
</div>
